import { createAsyncThunk } from "@reduxjs/toolkit"

import { googleLogin } from "src/store/user"
import { loadUserData } from "src/store/auth"

/* The Google half of `login.js`, and deliberately the same shape.

   Signing in has two halves whichever button was pressed: get tokens, then load who you are and
   what you are in the middle of. Only the first half differs, so only the first half is written
   twice — a component calls this, gets the same promise, and hides the modal the same way. */
export const loginWithGoogle = createAsyncThunk(
  "auth/loginWithGoogle",
  async (credential, { dispatch, rejectWithValue }) => {
    try {
      await dispatch(googleLogin(credential))
      await dispatch(loadUserData())
      return
    } catch (error) {
      return rejectWithValue(error)
    }
  }
)
